import { createContext } from "react";
import { DifficultWord } from "./types";

export const DifficultWordsContext = createContext<Array<DifficultWord>>([]);
